import FormInputText from './../Partials/FormInputText';
import FormInputTextArea from './../Partials/FormInputTextArea';
import FormInputUpload from './../Partials/FormInputUpload';
import MetaColumn from './MetaColumn';
import GeneralForm from './../Forms/GeneralForm';

const AppPageBuilder = {
    component: GeneralForm,
    options: {
        columns: {
            meta: MetaColumn,
            contents: [
                {
                    field: "heading",
                    partial: {
                        handler: FormInputText,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "heading");
                            },
                            required: true,
                            label: "سرصفحه"
                        }
                    }
                },
                {
                    field: "description",
                    partial: {
                        handler: FormInputTextArea,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "description");
                            },
                            required: true,
                            label: "توضیحات",
                            textSize: 7
                        }
                    }
                },
                {
                    field: "apps",
                    partial: {
                        handler: (props)=> {
                            return props.formHandler.buildArrayInputs("contents", "apps", "برنامه ها", {
                                src: {
                                    partial: {
                                        handler: FormInputUpload,
                                        props: {
                                            required: false,
                                            label: "عکس",
                                            preview_style : {width: '250px', height: '250px', margin: '10px'}
                                        }
                                    },
                                },
                                href: {
                                    props: {
                                        style: {
                                            direction: "ltr"
                                        }
                                    },
                                    label: "لینک"
                                },
                                title: {
                                    label: "عنوان"
                                }
                            })
                        },
                    }
                }
            ]
        }
    }
};

export default AppPageBuilder;


// WEBPACK FOOTER //
// ./src/containers/Pages/Builders/AppPageBuilder.js